'use es6';

import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CHANNEL_FETCHING_ERROR_BASE = 'slackUiLibrary.shareToSlackSidePanel.alerts.channelsFetching.error.failedToLoadChannels';
function FailedToLoadChannelsBanner({
  shouldShow = false
}) {
  return shouldShow && /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${CHANNEL_FETCHING_ERROR_BASE}.title`
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${CHANNEL_FETCHING_ERROR_BASE}.message`
    })
  });
}
export default FailedToLoadChannelsBanner;